import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const DropdownMeta: ComponentMeta = {
  componentName: "Dropdown",
  package: "@mijadesign/web",
  title: "下拉菜单",
  description: "下拉菜单组件，用于展示可点击的操作菜单",
  category: ComponentCategory.NAVIGATION,
  icon: "MenuOutlined",
  canHaveChildren: true,
  acceptedChildren: ["Button"],
  props: [
    {
      name: "overlay",
      label: "菜单内容",
      type: PropType.JSON,
      description: "菜单内容，使用 Menu 组件结构",
      group: "内容",
    },
    {
      name: "trigger",
      label: "触发方式",
      type: PropType.ARRAY,
      defaultValue: ["hover"],
      options: [
        { label: "悬停", value: "hover" },
        { label: "点击", value: "click" },
        { label: "右键", value: "contextMenu" },
      ],
      group: "行为",
    },
    {
      name: "placement",
      label: "弹出位置",
      type: PropType.ENUM,
      defaultValue: "bottomLeft",
      options: [
        { label: "底部左", value: "bottomLeft" },
        { label: "底部", value: "bottom" },
        { label: "底部右", value: "bottomRight" },
        { label: "顶部左", value: "topLeft" },
        { label: "顶部", value: "top" },
        { label: "顶部右", value: "topRight" },
      ],
      group: "布局",
    },
    {
      name: "visible",
      label: "是否显示",
      type: PropType.BOOLEAN,
      group: "状态",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "overlayClassName",
      label: "弹出层类名",
      type: PropType.STRING,
      group: "样式",
    },
    {
      name: "overlayStyle",
      label: "弹出层样式",
      type: PropType.OBJECT,
      group: "样式",
    },
  ],
  defaultProps: {
    trigger: ["hover"],
    placement: "bottomLeft",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Dropdown",
  },
  snippet: {
    componentName: "Dropdown",
    package: "@mijadesign/web",
    props: { trigger: ["hover"], placement: "bottomLeft" },
  },
};

export const DropdownButtonMeta: ComponentMeta = {
  componentName: "Dropdown.Button",
  package: "@mijadesign/web",
  title: "下拉按钮",
  description: "带下拉菜单的按钮组件",
  category: ComponentCategory.NAVIGATION,
  icon: "FileAddOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "overlay",
      label: "菜单内容",
      type: PropType.JSON,
      group: "内容",
    },
    {
      name: "trigger",
      label: "触发方式",
      type: PropType.ARRAY,
      defaultValue: ["hover"],
      group: "行为",
    },
    {
      name: "placement",
      label: "弹出位置",
      type: PropType.ENUM,
      defaultValue: "bottomLeft",
      options: [
        { label: "底部左", value: "bottomLeft" },
        { label: "底部", value: "bottom" },
        { label: "底部右", value: "bottomRight" },
      ],
      group: "布局",
    },
    {
      name: "type",
      label: "按钮类型",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "主按钮", value: "primary" },
        { label: "虚线", value: "dashed" },
        { label: "文本", value: "text" },
        { label: "链接", value: "link" },
      ],
      group: "样式",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
    {
      name: "danger",
      label: "危险按钮",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
  ],
  defaultProps: {
    trigger: ["hover"],
    placement: "bottomLeft",
    type: "default",
    size: "middle",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Dropdown",
  },
  snippet: {
    componentName: "Dropdown.Button",
    package: "@mijadesign/web",
    props: { type: "primary", trigger: ["hover"] },
  },
};
